<template lang="html">
	<div
		class="omapi-subscribers-campaigns"
		:class="{
			'omapi-subscribers-campaigns__refreshing': isLoading,
			'omapi-subscribers-campaigns__no-data': !hasCampaigns,
		}"
	>
		<common-card class="omapi-card__no-padding">
			<table-base
				:headers="headers"
				:do-select-all="false"
				:is-loading="false"
				:show-footer="false"
				class="omapi-table"
			>
				<template v-if="campaignsToShow">
					<monsterleads-overview-row
						v-for="campaign in campaignsToShow"
						:key="campaign.id"
						:lead-campaign="campaign"
					></monsterleads-overview-row>
				</template>
			</table-base>
		</common-card>
		<monsterleads-table-pagination :page-total="campaignsToShow.length" />
	</div>
</template>

<script lang="js">
import { mapGetters, mapActions, mapState } from 'vuex';
import { pagination } from '@/monsterleads/mixins/pagination';

export default {
	mixins: [pagination],
	data() {
		return {
			headers: [
				{ name: 'Campaign Name', class: 'campaign-table-name' },
				{ name: 'Created On', class: 'campaign-table-created' },
				{ name: 'All Time Subscribers', class: 'campaign-table-stats' },
				{ name: 'Last 30 Day Subscribers', class: 'campaign-table-stats' },
			],
		};
	},
	computed: {
		...mapGetters(['connected', 'shouldFetchUser']),
		...mapState('monsterleads', ['campaigns', 'count']),
		isLoading() {
			return this.shouldFetchUser || this.$store.getters.isLoading('lead-campaigns');
		},
		campaignsToShow() {
			if (this.connected) {
				return this.campaigns;
			}
			return [];
		},
		hasCampaigns() {
			return 0 < this.count;
		},
	},
	methods: {
		...mapActions('monsterleads', {
			fetch: 'fetchLeadsCampaigns',
		}),
	},
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.omapi-subscribers-overview .omapi-subscribers-campaigns {
	width: 100%;
	.omapi-table {
		border: none;
		&.striped > tbody > :nth-child(odd) {
			background-color: $color_white-button-background;
		}
		th {
			padding: 14px 30px;
			font-size: 13px;
			line-height: 1.5em;
			color: $color_black;
			border-bottom-color: $color_grey-light;
			&.campaign-table-created {
				width: 110px;
			}
		}
		td {
			padding: 13px 13px 13px 9px;
		}
		.campaign-table-name {
			padding-left: 30px;
			&__title {
				color: $color_black;
				font-weight: $font_bold;
				margin-bottom: 1px;
			}
		}
		.campaign-table-stats,
		.campaign-table-created {
			text-align: center;
		}
	}
	.omapi-pagination {
		display: flex;
		justify-content: flex-end;
	}

	&__refreshing {
		opacity: 0.5;
		&.omapi-subscribers-campaigns__no-data {
			td {
				padding-top: 34px;
				padding-bottom: 33px;
			}
		}
	}
}
</style>
